<template>
  <b-container fluid>
    <b-col v-if="!files.length" cols="12" class="py-5 text-center">
      <h3 class="font-weight-bold">This lot is vacant</h3>
      <p class="text-secondary">You have no files yet.</p>
      <b-img fluid src="/img/empty-req.svg" alt="Empty File Requests"></b-img>
    </b-col>
    <b-row v-else class="p-0 flex-row flex-nowrap overflow-auto">
      <div class="mb-4 card-container" v-for="file in files" :key="file.id">
        <file-item
          :file="file"
          :selectedFiles="selectedFiles"
          :is-requests-files-page="isRequestsFilesPage"
          @clearFilesSelected="clearFilesSelected"
          @checkFile="checkFile"
          @uncheckFile="uncheckFile"
          @shareFile="shareSingleFile(file)"
        />
      </div>
    </b-row>

    <b-alert
      dismissible
      fade
      class="custom-alert"
      :show="dismissCountDown"
      :variant="alertType"
      @dismissed="clearAlert"
      @dismiss-count-down="dlCountDownChanged"
    >
      {{ alertMsg }}
    </b-alert>
  </b-container>
</template>

<script>
import FileItem from '@/components/cards/FileItem'

export default {
  components: {
    FileItem
  },

  props: {
    files: {
      type: Array,
      required: true,
      default() {
        return []
      }
    },
    isRequestsFilesPage: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      loading: false,
      selectedFiles: [],
      dismissCountDown: 0,
      alertMsg: null,
      alertType: 'primary'
    }
  },

  methods: {
    clearFilesSelected() {
      this.selectedFiles = []
    },
    async downloadSelectedFiles() {
      this.loading = true

      await this.$api
        .get('/download-bulk-files', {
          params: {
            files: this.selectedFiles
          }
        })
        .then(response => {
          this.loading = false
          this.clearFilesSelected()

          this.alertMsg = 'Requested download file successful!'
          this.dismissCountDown = 5
        })
        .catch(e => {
          this.loading = false

          setTimeout(e => {
            this.clearAlert()
          }, 5000)

          this.alertType = 'danger'
          this.alertMsg =
            'Something went wrong while downloading selected files!'
          this.dismissCountDown = 5
        })
    },
    dlCountDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    clearAlert() {
      this.dismissCountDown = 0
      this.alertMsg = null
      this.alertType = 'primary'
    },
    checkFile(file) {
      const index = this.selectedFiles.findIndex(f => f === file)

      if (index < 0) {
        this.selectedFiles.push(file)
      }

      this.$emit('selectedFiles', this.selectedFiles)
    },
    uncheckFile(file) {
      const index = this.selectedFiles.findIndex(f => f === file)

      if (index >= 0) {
        this.selectedFiles.splice(index, 1)
        this.$emit('selectedFiles', this.selectedFiles)
      }
    },
    shareSingleFile(file) {
      this.clearFilesSelected()
      this.checkFile(file.id)
      this.$emit('shareSingleFile', file)
    }
  }
}
</script>

<style lang="scss" scoped>
.card-container {
  margin: 0 0.5rem;

  &:first-child {
    margin-left: 0 !important;
    margin-right: 0.5rem !important;
  }

  &:last-child {
    margin-left: 0.5rem !important;
    margin-right: 0 !important;
  }
}
</style>
